import { render } from "./ButtonBack.vue?vue&type=template&id=676dce9c"
import script from "./ButtonBack.vue?vue&type=script&lang=js"
export * from "./ButtonBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__